import React from 'react';
import styled from 'styled-components';
import { useAuth } from '@/auth/SessionAuth';

const StyledButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  display: inline;
  margin: 0;
  padding: 0;
  font-size: 16px;
`;

type LinkButtonProps = {
  text: string;
  deliveryName: string,
  path: string,
};

const LinkButton: React.FC<LinkButtonProps> = (props) => {
  const { text, deliveryName, path } = props;
  const { apiFetch } = useAuth();

  async function handleOnClick() {
    const response = await apiFetch(
      `/${deliveryName}/${encodeURIComponent(path)}`
    );

    if (!response.ok) return;

    const blob = await response.blob();
    const url = window.URL.createObjectURL(
      new Blob([blob]),
    );
    
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      text
    );

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    // @ts-ignore
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  return (
    <StyledButton
      onClick={handleOnClick}
    >
      {text}
    </StyledButton>
  );
};

export default LinkButton;